import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, DestroyRef, inject, signal } from '@angular/core';
import { HomeDashboard, HomeService } from './home.service';
import iconLibrary from 'src/app/common/iconLibrary';

export enum Sort {
  LAST_USED = "LAST_USED",
  OTHER = "OTHER"
}

export enum Analysis {
  PRESET = "PRESET"
}

const DASHBOARD_ID_PARAM = 'dashboardId';

@Component({
  selector: 'wct-home',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  providers: [HomeService]
})
export class HomeComponent {

  readonly service = inject(HomeService);

  readonly Sort = Sort;
  readonly Analysis = Analysis;
  protected readonly iconLibrary = iconLibrary;

  readonly selectedAnalysis = signal<string | undefined>(this.readDashboardIdFromUrl());
  readonly selected = signal<string[]>([Analysis.PRESET]);
  readonly sort = signal<Sort>(Sort.LAST_USED);

  readonly available = this.service.available;

  constructor() {
    this.service.refreshDashboards().catch(err => console.error('Dashboards konnten nicht geladen werden', err));
    const onPopState = () => this.selectedAnalysis.set(this.readDashboardIdFromUrl());
    window.addEventListener('popstate', onPopState);
    inject(DestroyRef).onDestroy(() => window.removeEventListener('popstate', onPopState));
  }

  readonly visible = computed(() => {
    let visible = [] as Array<HomeDashboard>;
    if (this.isSelected(Analysis.PRESET)) {
      visible = [...visible, ...this.available()];
    }
    return visible;
  })

  sortText(key: Sort) {
    switch (key) {
      case Sort.LAST_USED:
        return 'zuletzt verwendet';
      default:
        return 'andere';
    }
  };

  toggleSelection(selection: Analysis) {
    if (this.isSelected(selection)) {
      this.selected.update(v => v.filter(v => v != selection));
    } else {
      this.selected.update(v => [...v, selection]);
    }
  }

  isSelected(selection: Analysis) {
    return this.selected().indexOf(selection) >= 0;
  }

  openAnalysis(id: string) {
    this.selectedAnalysis.set(id);
    const url = new URL(window.location.href);
    url.searchParams.set(DASHBOARD_ID_PARAM, id);
    window.history.pushState({}, '', url);
  }

  private readDashboardIdFromUrl(): string | undefined {
    return new URLSearchParams(window.location.search).get(DASHBOARD_ID_PARAM) ?? undefined;
  }

}
